import { useCallback } from 'react';
import { useToastContext } from '@sato/components';

import { t } from '@stores/localization/localization.store';

import { apartmentStore } from './apartmentStore';

/**
 * Returns a function for switching the selected apartment programmatically, i.e. without the user using the
 * apartment selector. Notifies the user about the switch, since the content of the page changes under them.
 */
export const useSwitchApartment = () => {
  const { addToast, clearToasts } = useToastContext();

  return useCallback(
    (apartmentId: string) => {
      const apartment = apartmentStore.apartments?.find(
        (apartment) => apartment.apartmentId === apartmentId
      );

      if (!apartment) return;

      apartmentStore.setSelectedApartmentID(apartmentId);

      clearToasts();

      addToast({
        icon: 'info24',
        message: t('apartment_switched_toast', { address: apartment.address }),
        duration: 5000,
        // Do not hide main navigation on mobile underneath the toast
        className: 'mdDown:mt-9',
      });
    },
    [addToast, clearToasts]
  );
};
